import React from "react";

const QuestionList = ({ questions }) => {
  return (
    <div style={{ marginLeft: "20px", flex: 1 }}>
      <h3>Questions</h3>
      <div>
        <h4>Across</h4>
        {questions
          .filter((q) => q.direction === "across")
          .map((question, index) => (
            <div key={index}>
              <strong
                style={{
                  display: "inline-block",
                  width: "40px",
                  textAlign: "center",
                }}
              >
                {question.question_number}.
              </strong>
              {question.question_text} ({question.length})
            </div>
          ))}
      </div>
      <div>
        <h4>Down</h4>
        {questions
          .filter((q) => q.direction === "down")
          .map((question, index) => (
            <div key={index}>
              <strong
                style={{
                  display: "inline-block",
                  width: "40px",
                  textAlign: "center",
                }}
              >
                {question.question_number}.
              </strong>
              {question.question_text} ({question.length})
            </div>
          ))}
      </div>
    </div>
  );
};

export default QuestionList;
